import axios from "axios";
import moment from "moment";

const checkUrl = () => {
  // 浏览器环境优先：host 包含 h5-blogs-test 或为 localhost 时视为 production
  if (typeof window !== 'undefined') {
    const host = (window.location && window.location.hostname) || '';
    if (host.indexOf('h5-blogs-test') > -1 || host === 'localhost') {
      console.log(window.location.hostname,'host');
      return "https://pigeon-test.ihealthcn.com";
    }
  }
  if (process.env.NODE_ENV === 'production') {
    return "https://pigeon.ihealthcn.com";
  } else {
    return "https://pigeon-test.ihealthcn.com";
  }
};
export default class BuriedPoint {
  // 暂存需要上传的埋点
  static listLog = [];

  /**
   * 提交埋点（单条）
   * @param {Object} data 上报数据
   * @param {number} retry 剩余重试次数
   */
  static async commitSaLog(data, retry = 3) {
    const url = `${checkUrl()}/needleLog`;
    try {
      await axios.post(
        url,
        { ...data },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (err) {
      if (retry > 0) {
        return this.commitSaLog(data, retry - 1);
      }
    }
  }

  /**
   * 批量上传埋点
   * @param {Array<Object>} data 批量数据
   */
  static commitListSaLog(data) {
    this.commitSaLog({ list: data });
  }

  /**
   * 发送埋点
   * @param {string} eventName 事件名
   * @param {Object} properties 事件属性
   * @param {boolean} force 是否立即上报（true 为立即单条上报；false 为批量）
   */
  static saLog(eventName, properties = {}, force = true) {
    if (force) {
      return this.commitSaLog({
        payload: properties.payload,
        eventName,
        patientId: properties.id,
        env: process.env.NODE_ENV === "production" ? "PRODUCTION" : "STAGING",
        whichApp: "h5-blogs",
        clientTime: moment().format(),
      });
    }

    this.listLog.push({
      eventName,
      params: {
        ...properties,
      },
    });

    // 积累到 10 条立即批量上传
    if (this.listLog.length >= 10 && this.timer) {
      this.commitListSaLog(this.listLog.splice(0));
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/log.js